<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">List</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content">
  <h2>Use case 1</h2>
  <div class="c-list" id="listGroupId">
    <maced-list-group listGroupId="listGroupId2" role="list">
      <maced-list listId="listId1" label="label" role="listitem">
        <maced-badge badgeId="badgeId1" label="90" labelText="notifications" ariaLabel="Ninty" size="small"></maced-badge>
      </maced-list>
      <maced-list listId="listId2" label="label" ariaLabel="label" role="listitem">
        <maced-badge badgeId="badgeId2" label="110" labelText="notifications" ariaLabel="One Hundred & Ten" size="medium"></maced-badge>
      </maced-list>
      <maced-list listId="listId3" label="label" ariaLabel="label" trailingIcon="icon-chevron-right" role="listitem">
      </maced-list>
      <maced-list listId="listId4" label="label" ariaLabel="label" leadingIcon="icon-message-dots-circle"
        role="listitem">
      </maced-list>
      <maced-list listId="listId9" label="label" ariaLabel="label" leadingIcon="icon-message-dots-circle"
        role="listitem">
        <maced-badge badgeId="badgeId9" label="90" labelText="notifications" ariaLabel="Ninty" size="small"></maced-badge>
      </maced-list>
      <maced-list listId="listId5" label="Active Mode" ariaLabel="Active Mode" [active]="true" role="listitem">
      </maced-list>
      <maced-list listId="listId6" label="Disabled Mode" ariaLabel="Disabled Mode" [disabled]="true" role="listitem">
      </maced-list>
      <maced-list listId="listId7" label="With Url" ariaLabel="With Url" url="/card" role="listitem">
      </maced-list>
      <maced-list listId="listId8" label="With queryParams" ariaLabel="With queryParams" url="/card"
        [queryParams]="queryParams" role="listitem">
      </maced-list>
    </maced-list-group>
  </div>
  <br>
  <h2>Use case 2</h2>
  <div class="c-list" id="listGroupId11" [ngClass]="{'c-list--horizontal': isHorizontal}">
    <maced-list-group listGroupId="listGroupId1" role="list">
      <maced-list listId="listId11" label="label" ariaLabel="label" role="listitem">
        <maced-badge badgeId="badgeId11" label="90" labelText="notifications" ariaLabel="Ninty" size="dot"></maced-badge>
      </maced-list>
      <maced-list listId="listId22" label="label" ariaLabel="label" role="listitem">
        <maced-badge badgeId="badgeId22" label="110" labelText="notifications" ariaLabel="One Hundred & Ten" size="dot"></maced-badge>
      </maced-list>
      <maced-list listId="listId33" label="label" ariaLabel="label" trailingIcon="icon-chevron-right" role="listitem">
      </maced-list>
      <maced-list listId="listId44" label="label" ariaLabel="label" leadingIcon="icon-message-dots-circle"
        role="listitem">
      </maced-list>
      <maced-list listId="listId99" label="label" ariaLabel="label" leadingIcon="icon-message-dots-circle"
        role="listitem">
        <maced-badge badgeId="badgeId99" label="90" labelText="notifications" ariaLabel="Ninty" size="dot"></maced-badge>
      </maced-list>
      <maced-list listId="listId55" label="Active Mode" ariaLabel="Active Mode" [active]="true" role="listitem">
      </maced-list>
      <maced-list listId="listId66" label="Disabled Mode" ariaLabel="Disabled Mode" [disabled]="true" role="listitem">
      </maced-list>
      <maced-list listId="listId77" label="With Url" ariaLabel="With Url" url="/card" role="listitem">
      </maced-list>
      <maced-list listId="listId88" label="With queryParams" ariaLabel="With queryParams" url="/card"
        [queryParams]="queryParams" role="listitem">
      </maced-list>
    </maced-list-group>
  </div>
</div>